import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { Button, Badge } from 'react-bootstrap';
import HelperPopover from '../HelperPopover';
import AdvancedFilterModal from './AdvancedFilterModal';
import CaseFilterModal from './CaseFilterModal';
import DateFilterModal from './DateFilterModal';
import FinancialFilterModal from './FinancialFilterModal';
import ScheduleFilterModal from './ScheduleFilterModal';

import '../AdvancedSearch.less';

const ResultForm = ({ onSubmit, filter, onReset }) => {
  const [isAdvancedFilterModalOpen, setIsAdvancedFilterModal] = useState(false);
  const [isCaseFilterModalOpen, setIsCaseFilterModal] = useState(false);
  const [isDateFilterModalOpen, setIsDateFilterModal] = useState(false);
  const [isFinancialFilterModalOpen, setIsFinancialFilterModal] = useState(false);
  const [isScheduleFilterModalOpen, setIsScheduleFilterModal] = useState(false);

  const handleSubmitClick = values => {
    onSubmit({ ...values, page: 0 });
  };

  const countSubFilter = (fields = []) =>
    fields.filter(key => {
      return !(!filter[key] || (filter[key] && filter[key].length === 0));
    }).length;

  const caseCounter = countSubFilter(['court_code', 'query', 'chapter', 'case_type', 'nature_of_suit']) + 1;
  const financialCounter = countSubFilter(['industry', 'assets', 'liabilities']) + 1;
  const scheduleCounter = countSubFilter(['schedule', 'schedule_category', 'schedule_value_from', 'schedule_value_to']);
  const dateCounter = countSubFilter([
    'date_filed_from',
    'date_filed_to',
    'date_closed_from',
    'date_closed_to',
    'date_dismissed_from',
    'date_dismissed_to',
    'date_discharged_from',
    'date_discharged_to',
    'date_doc_filed_from',
    'date_doc_filed_to',
    'open_cases_from',
    'open_cases_to',
  ]);

  return (
    <section>
      <Form
        onSubmit={handleSubmitClick}
        initialValues={filter}
        render={({ handleSubmit, form }) => (
          <form onSubmit={handleSubmit} className="advanced-search-form">
            <div className="form-item form-item-btn">
              <HelperPopover>
                <Field
                  name="keys"
                  component="input"
                  type="text"
                  placeholder={
                    filter.tab === 'cases' ? 'Enter case title, party name or case number' : 'Enter Keywords'
                  }
                  className="form-input keys"
                />
              </HelperPopover>
              <button
                type="submit"
                className="btn btn-success btn-search btn-blink"
                key={filter.tab} // setting the key will re-render the button on tab change and show the animation
              >
                Search
              </button>
            </div>
            <div className="action-btn-container">
              <Button bsStyle="primary" onClick={() => setIsAdvancedFilterModal(true)}>
                Advanced Filters <Badge>2</Badge>
              </Button>
              <Button bsStyle="primary" onClick={() => setIsCaseFilterModal(true)}>
                Case <Badge>{caseCounter}</Badge>
              </Button>
              {filter.court_type === 'bankruptcy' && (
                <Button bsStyle="primary" onClick={() => setIsFinancialFilterModal(true)}>
                  Financial <Badge>{financialCounter}</Badge>
                </Button>
              )}
              {filter.tab === 'schedules' && (
                <Button
                  bsStyle={scheduleCounter > 0 ? 'primary' : 'default'}
                  onClick={() => setIsScheduleFilterModal(true)}
                >
                  Schedule {scheduleCounter > 0 && <Badge>{scheduleCounter}</Badge>}
                </Button>
              )}
              <Button bsStyle={dateCounter > 0 ? 'primary' : 'default'} onClick={() => setIsDateFilterModal(true)}>
                Date {dateCounter > 0 && <Badge>{dateCounter}</Badge>}
              </Button>
              <button
                type="button"
                className="btn btn-link pull-right"
                onClick={() => {
                  form.reset();
                  onReset();
                }}
              >
                Start Over
              </button>
            </div>
          </form>
        )}
      />

      {isAdvancedFilterModalOpen && (
        <AdvancedFilterModal
          show={isAdvancedFilterModalOpen}
          onClose={() => setIsAdvancedFilterModal(false)}
          onSave={values => {
            onSubmit(values);
            setIsAdvancedFilterModal(false);
          }}
          filter={filter}
        />
      )}
      {isCaseFilterModalOpen && (
        <CaseFilterModal
          show={isCaseFilterModalOpen}
          onClose={() => setIsCaseFilterModal(false)}
          onSave={values => {
            onSubmit(values);
            setIsCaseFilterModal(false);
          }}
          filter={filter}
        />
      )}
      {isDateFilterModalOpen && (
        <DateFilterModal
          show={isDateFilterModalOpen}
          onClose={() => setIsDateFilterModal(false)}
          onSave={values => {
            onSubmit(values);
            setIsDateFilterModal(false);
          }}
          filter={filter}
        />
      )}
      {isFinancialFilterModalOpen && filter.court_type === 'bankruptcy' && (
        <FinancialFilterModal
          show={isFinancialFilterModalOpen}
          onClose={() => setIsFinancialFilterModal(false)}
          onSave={values => {
            onSubmit(values);
            setIsFinancialFilterModal(false);
          }}
          filter={filter}
        />
      )}
      {isScheduleFilterModalOpen && filter.tab === 'schedules' && (
        <ScheduleFilterModal
          show={isScheduleFilterModalOpen}
          onClose={() => setIsScheduleFilterModal(false)}
          onSave={values => {
            onSubmit(values);
            setIsScheduleFilterModal(false);
          }}
          filter={filter}
        />
      )}
    </section>
  );
};

ResultForm.propTypes = {
  filter: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};

export default ResultForm;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/resultForms/ResultForm.jsx